@if (isInitialized) {
    <div class="ws-flex-container-vertical ws-flex-auto">
        @if (!isEmbeddedMode) {
            <ws-bread-crumbs [breadcrumbs]="breadcrumbs" currentPageTitle="Assets"></ws-bread-crumbs>
        }
        <div class="ws-section">
            <div class="ws-section__header">
                <h4 class="ws-section__header__title">
                    Assets
                    <small>
                        {{ isLienDatePrior ? ' Assets present on or carried forward to ' + (lienDate.date | weissmanDateFormat) : '' }}
                        {{ isLienDateExact ? ' Assets present or confirmed present on ' + (lienDate.date | weissmanDateFormat) : '' }}
                        {{ lienDate && lienDate.useStateLienDate ? 'only states utilizing ' + (lienDate.date | weissmanMonthDayDateFormat) + ' lien date' : '' }}
                    </small>
                    <ag-grid-row-count [gridApi]="gridApi"
                                       [gridTracker]="gridTracker"
                                       [gridOptions]="gridOptions"></ag-grid-row-count>
                </h4>
                <div class="ws-section__header__actions">
                    @if (!isEmbeddedMode) {
                        <div class="ws-section__header__actions__item">
                            <div><small class="me-2">View:</small></div>
                            <div dropdown container="body" placement="bottom right">
                                <button id="button-basic"
                                        dropdownToggle
                                        type="button"
                                        class="ace-btn btn-link btn-sm dropdown-toggle"
                                        aria-controls="dropdown-basic"
                                        [disabled]="refreshing">
                                    {{ selectedGridSourceOption.name }}
                                    <span class="caret"></span>
                                </button>
                                <ul id="dropdown-basic"
                                    *dropdownMenu
                                    class="dropdown-menu dropdown-menu-end"
                                    role="menu"
                                    aria-labelledby="button-basic">
                                    @for (gso of gridSourceOptions; track gso) {
                                        <li role="menuitem">
                                            <a class="pointer"
                                               (click)="setSelectedGridSourceOption(gso)"
                                               helpTooltip
                                               [helpContentId]="getListViewHelpContentId(gso.name)"
                                               position="right">{{ gso.name }}</a>
                                        </li>
                                    }
                                </ul>
                            </div>
                        </div>
                    }
                    @if (canEdit && !isEmbeddedMode) {
                        <div class="ws-section__header__actions__item">
                            <button type="button"
                                    class="ace-btn btn-primary btn-sm"
                                    (click)="addAsset()"
                                    helpTooltip
                                    helpContentId="asset-list.new-asset"
                                    position="bottom"
                                    [disabled]="!lienDate">
                                New Asset
                            </button>
                        </div>
                    }
                    @if (isEmbeddedMode) {
                        <div class="ws-section__header__actions__item">
                            <a [href]="filterHref">View Full Asset List</a>
                        </div>
                    }
                    <div class="ws-section__header__actions__item">
                        <button type="button"
                                class="ace-btn btn-sm btn-secondary has-icon"
                                (click)="refresh()"
                                helpTooltip
                                helpContentId="app.refresh"
                                position="bottom"
                                [disabled]="refreshing">
                            <i class="fa fa-refresh"></i></button>
                    </div>
                </div>
            </div>
            @if (activeImportLongRunningProcessId) {
                <div class="asset-import-in-progress" (click)="openAssetImportInProgressModal()">
                    <div class="message"><i class="fa fa-info-circle" style="padding-right: 5px;"></i>Asset import in
                        progress
                    </div>
                    @if (activeImportLongRunningProcessId && !activeImportSelectedRowsCount) {
                        <div class="loadingMetadata"><ws-ace-loader [inline]="true"></ws-ace-loader></div>
                    }
                    @if (activeImportLongRunningProcessId && activeImportSelectedRowsCount) {
                        <div>Importing: {{ activeImportProcessedRowsCount }}
                            of {{ this.activeImportSelectedRowsCount }}
                        </div>
                    }
                    @if (activeImportLongRunningProcessId && activeImportSelectedRowsCount) {
                        <div class="timeRemaining">Time left: {{ activeImportTimeRemaining }}</div>
                    }
                </div>
            }
            <div class="ws-section__filters">
                <div class="ws-section__filters__filter-group" [hidden]="!importFilterOptionVisible">
                    <label for="importFilteredBy">Filter By:</label>
                    <select id="importFilteredBy"
                            class="form-select form-select-sm"
                            [ngModel]="selectedImportGridFilterOption"
                            (ngModelChange)="onImportGridFilterChanged($event)">
                        @for (gfo of importGridFilterOptions; track gfo) {
                            <option [ngValue]="gfo">{{ gfo.name }}</option>
                        }
                    </select>
                </div>
                <div class="ws-section__filters__filter-group" [hidden]="!lienDateVisible">
                    <div class="ws-flex-container-horizontal ws-flex-align-items-center">
                        <label class="ws-flex-none"
                               for="assetLienDate"
                               helpTooltip
                               helpContentId="asset-list.lien-date"
                               position="bottom">Lien Date:</label>
                        <asset-lien-date id="assetLienDate"
                                         [useSavedLienDate]="true"
                                         [saveLienDate]="true"
                                         [showFilters]="true"
                                         size="md"
                                         [companyId]="companyId"
                                         (dateChange)="onLienDateChanged($event)"
                                         style="margin-left: 8px">
                        </asset-lien-date>
                    </div>
                </div>
                <div class="ws-section__filters__filter-group" [hidden]="isEmbeddedMode || !lienDateVisible">
                    <div class="ws-flex-container-horizontal ws-flex-align-items-center">
                        <label class="ws-flex-none"
                               for="assetAdvanced"
                               helpTooltip
                               helpContentId="asset-list.asset-changes-filter"
                               position="bottom">Show:</label>
                        <asset-advanced id="assetAdvanced"
                                        [assetDescriptors]="assetDescriptors"
                                        (optionChange)="onAdvancedOptionChanged($event)"></asset-advanced>
                    </div>
                </div>
                <div class="ws-section__filters__filter-group" [hidden]="!furtherLimitVisible">
                    <div class="ws-flex-container-horizontal ws-flex-align-items-center">
                        <label class="ws-flex-none"
                               for="assetLimit"
                               helpTooltip
                               helpContentId="asset-list.further-limit-to"
                               position="bottom">Further Limit To:</label>
                        <asset-limit id="assetLimit"
                                     [assetDescriptors]="assetDescriptors"
                                     (optionChange)="onLimitOptionChanged($event)"></asset-limit>
                    </div>
                </div>
                <div class="ws-section__filters__filter-group" [hidden]="!importFileListVisible">
                    <div class="ws-flex-container-horizontal ws-flex-auto ws-flex-align-items-center">
                        <label for="selectedImportFile" class="ws-flex-none">Import File:</label>
                        <select id="selectedImportFile"
                                class="form-select form-select-sm"
                                [ngModel]="selectedImportFileId"
                                (ngModelChange)="onSelectedImportFileChanged($event)">
                            @for (importFile of importFiles; track importFile) {
                                <option [ngValue]="importFile.importFileId">{{ importFile.displayName }}</option>
                            }
                        </select>
                    </div>
                </div>
                <div class="ws-section__filters__filter-group">
                    <div class="ws-flex-container-horizontal ws-flex-auto ws-flex-align-items-center">
                        <button type="button"
                                class="ace-btn btn-sm btn-primary"
                                (click)="refresh()"
                                helpTooltip
                                helpContentId="asset-list.apply-filters"
                                position="bottom"
                                [disabled]="refreshing">
                            Apply
                        </button>
                    </div>
                </div>
                @if (gridId) {
                    <div class="ws-section__filters__filter-group right-align-layout-name">
                        <ag-grid-current-layout-applied [gridId]="gridId"></ag-grid-current-layout-applied>
                    </div>
                }
            </div>
        </div>
        @if(gridId) {
            <ws-ag-grid-angular (gridReady)="onAgGridReady($event)"
                                [companyId]="companyId"
                                [gridOptions]="gridOptions"
                                [gridId]="gridId"
                                [isBulkUpdateVisible$]="isBulkUpdateVisible$"
                                [isBulkDeleteVisible$]="isBulkDeleteVisible$"
                                [exportOptions]="exportOptions"
                                [defaultSizeToFit]="false"
                                (bulkUpdate)="bulkUpdate()"
                                (bulkDelete)="bulkDelete()">
            </ws-ag-grid-angular>
        }
    </div>
}
